import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function InvoiceContentReducer(state = initialState.invoiceContent, action: any) {
  switch (action.type) {
    case types.SAVE_INVOICECONTENT_SUCCESS:
      return action.invoiceContent;
    default:
      return state;
  }
}
